module.exports = __webpack_public_path__ + "img/avatar0.827671da.png";